module.exports = function() {
  return new Worker(__webpack_public_path__ + "462d4e3a366619bf5557.worker.js");
};